<template>
  <v-container fluid v-if="selectedSection">
    <Title :src="'menu'" :text="getDepartmentDisplayName(menu.category_id)" />
    <div class="mb-3">
      <v-row class="background-color-white mr-sm-0" justify="space-between">
        <v-col class="pl-10">
          <h5 class="font-size-lg font-weight-medium">{{ selectedSection }}</h5>
        </v-col>
      </v-row>
      <v-row class="background-color-white mr-sm-0 px-6">
        <v-col
          v-for="item in menuItems[selectedSection]"
          :key="item.upc"
          class="position-relative mb-5"
          cols="6"
          md="3"
          xl="2"
        >
          <Product :product="item" :size="'md'" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { slug } from "github-slugger";
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";

export default {
  name: "Menu",
  components: { Product, Title },
  methods: { slug },
  props: { menu: Object, menuItems: Object },
  computed: {
    ...mapGetters("departments", {
      getDepartmentDisplayName: "getDepartmentDisplayName",
    }),
    ...mapGetters('menu', ['selectedSection']),
  },
};
</script>
